import Vue from 'vue'
import Cart from './components/Cart.vue'
import vueCustomElement from 'vue-custom-element'

Vue.use(vueCustomElement);

Vue.customElement('cart-app', Cart, { shadow: false })
